import { all } from 'redux-saga/effects';
import * as DownloadTemplateSaga from '../download-template/downloadTemplate.saga';
import * as DataEditorSaga from 'modules/data-editor/redux/dataEditor.saga';
import * as MasterDataSaga from 'modules/master-data/redux/masterData.saga';
import * as PreviewDataSaga from 'common/redux/preview-data/previewData.saga';
import * as FileUploadSaga from 'common/redux/file-upload/fileUpload.saga';
import * as ConfigurationDataSaga from 'modules/configuration/redux/configuration.saga';
import * as ArchiveSaga from 'modules/archive/redux/archive.saga';
import * as AppUserSaga from 'common/redux/user/user.saga';
import * as EntitySaga from 'common/redux/entity/entity.saga';
import * as AppStateSaga from 'common/redux/app-state/appState.saga';
import * as SyncHistorySaga from 'modules/sync-history/redux/sync-history.saga';
import * as DataManagementSaga from 'modules/data-management/redux/data-management.saga';
import * as UserSaga from 'modules/user-management/redux/user.saga';

export default function* rootSaga() {
    yield all([
        DataEditorSaga.loadToMasterDataWatch(),
        DataEditorSaga.clearPreviewWatch(),

        DownloadTemplateSaga.downloadFileWatch(),

        MasterDataSaga.deleteDataWatch(),
        MasterDataSaga.getSearchListWatch(),
        MasterDataSaga.updateCategoryWatch(),
        MasterDataSaga.updateSubCategoryWatch(),
        MasterDataSaga.updateIndicatorWatch(),
        MasterDataSaga.addCategoryWatch(),
        MasterDataSaga.saveToMasterWatch(),
        MasterDataSaga.applyChangesWatch(),
        MasterDataSaga.addIndicatorWatch(),
        MasterDataSaga.linkIndicatorWatch(),
        MasterDataSaga.archiveWatch(),
        MasterDataSaga.getMasterDataWatch(),
        MasterDataSaga.getEntitiesByCategoryWatch(),
        MasterDataSaga.getHierarchicalDataWatch(),
        MasterDataSaga.getHierarchicalDataByCategoryWatch(),
        MasterDataSaga.addSubCategoryWatch(),
        MasterDataSaga.fetchSubCategoryWatch(),
        MasterDataSaga.fetchReviewStatusWatch(),
        MasterDataSaga.refreshEntitiesByCategoryWatch(),
        MasterDataSaga.moveSubCategoryWatch(),
        MasterDataSaga.resetMasterDataStateWatch(),
        MasterDataSaga.copyIndicatorWatch(),
        MasterDataSaga.moveIndicatorWatch(),
        MasterDataSaga.getDeleteFeasibilityWatch(),
        MasterDataSaga.getArchiveFeasibilityWatch(),
        MasterDataSaga.getChildSubCategoryDataWatch(),
        MasterDataSaga.isMovableSubCategoryWatch(),
        MasterDataSaga.discardChangesWatch(),
        MasterDataSaga.getCloneFeasibilityWatch(),
        MasterDataSaga.cloneEntityWatch(),
        MasterDataSaga.checkDuplicateIndicatorWatch(),

        PreviewDataSaga.loadPreviewDataWatch(),
        PreviewDataSaga.getSearchListWatch(),
        PreviewDataSaga.updateCategoryWatch(),
        PreviewDataSaga.updateSubCategoryWatch(),
        PreviewDataSaga.updateIndicatorWatch(),
        PreviewDataSaga.fetchErrorCountWatch(),
        PreviewDataSaga.deleteDataWatch(),
        PreviewDataSaga.getEntitiesByCategoryWatch(),

        FileUploadSaga.uploadFileWatch(),
        FileUploadSaga.uploadProgressWatch(),
        FileUploadSaga.getSyncDetailsWatch(),
        FileUploadSaga.fetchUploadStatusWatch(),

        ConfigurationDataSaga.deleteDataWatch(),
        ConfigurationDataSaga.getKeyIndicatorsWatch(),
        ConfigurationDataSaga.getStaticIndicatorsWatch(),
        ConfigurationDataSaga.fetchFrequentlyUsedWatch(),
        ConfigurationDataSaga.getTrendingDataWatch(),
        ConfigurationDataSaga.fetchWhatsNewWatch(),
        ConfigurationDataSaga.saveIndicatorAddWatch(),
        ConfigurationDataSaga.fetchGeographyOverviewWatch(),
        ConfigurationDataSaga.fetchUploadFileLogWatch(),
        ConfigurationDataSaga.reorderDataWatch(),
        ConfigurationDataSaga.reorderTrendingDataWatch(),
        ConfigurationDataSaga.deleteTrendingDataWatch(),
        ConfigurationDataSaga.getCategoriesWatch(),
        ConfigurationDataSaga.getHierarchicalDataByCategoryWatch(),
        ConfigurationDataSaga.saveTrendingDataWatch(),
        ConfigurationDataSaga.uploadFileFileWatch(),
        ConfigurationDataSaga.uploadProgressWatch(),
        ConfigurationDataSaga.deleteWhatsNewDataWatch(),
        ConfigurationDataSaga.saveWhatsNewIndicatorWatch(),
        ConfigurationDataSaga.reorderWhatsNewWatch(),
        ConfigurationDataSaga.saveWhatsNewLinkWatch(),
        ConfigurationDataSaga.getIndicatorSourcesWatch(),
        ConfigurationDataSaga.addIndicatorSourceWatch(),
        ConfigurationDataSaga.updateIndicatorSourceWatch(),
        ConfigurationDataSaga.deleteIndicatorSourceWatch(),
        ConfigurationDataSaga.saveVideoLinkAddWatch(),
        ConfigurationDataSaga.updateVideoLinkAddWatch(),
        ConfigurationDataSaga.fetchVideoLinkWatch(),
        ConfigurationDataSaga.deleteVideoLinkWatch(),

        ArchiveSaga.fetchArchiveListWatch(),
        ArchiveSaga.deleteArchivedDataWatch(),
        ArchiveSaga.getSearchListWatch(),
        ArchiveSaga.restoreWatch(),
        ArchiveSaga.getHierarchicalDataWatch(),
        ArchiveSaga.getHierarchicalDataByCategoryWatch(),
        ArchiveSaga.getEntitiesByCategoryWatch(),
        ArchiveSaga.fetchArchiveListBySearchWatch(),

        AppUserSaga.getUserAvatarWatch(),
        AppUserSaga.getUserProfileWatch(),
        AppUserSaga.getUserInfoWatch(),

        EntitySaga.getEntityDetailsByIdWatch(),
        EntitySaga.getCategoryByIdWatch(),
        EntitySaga.getIndicatorByIdWatch(),
        EntitySaga.getSourcesWatch(),

        SyncHistorySaga.fetchSyncLogsListWatch(),

        AppStateSaga.hideLoaderWatch(),
        AppStateSaga.showLoaderWatch(),

        UserSaga.getPermissionListWatch(),
        UserSaga.assignRoleWatch(),
        UserSaga.getRoleListWatch(),
        UserSaga.getRoleListWatch(),
        UserSaga.editRoleWatch(),
        UserSaga.assignRoleWatch(),
        UserSaga.deleteRoleWatch(),
        UserSaga.getUserListWatch(),

        DataManagementSaga.fetchCompanyFootprintsWatch(),
        DataManagementSaga.fetchCompanyInfoWatch(),
        DataManagementSaga.updateCompanyInfoWatch(),
        DataManagementSaga.updateLocationWiseCompanyFootprintWatch()
    ]);
}
